import styles from './ToolDescriptor.module.css'

interface ToolDescriptorProps {
  why: string
  what: string
  how: string
  when: string
}

export default function ToolDescriptor({ why, what, how, when }: ToolDescriptorProps) {
  return (
    <div data-testid="tool-descriptor">
      <div className={styles.subLabel}>Tool Descriptor</div>
      <div className={styles.row}>
        <div className={`${styles.box} ${styles.why}`} data-testid="desc-why">
          <div className={styles.label}>Why</div>
          {why}
        </div>
        <div className={`${styles.box} ${styles.what}`} data-testid="desc-what">
          <div className={styles.label}>What</div>
          {what}
        </div>
        <div className={`${styles.box} ${styles.how}`} data-testid="desc-how">
          <div className={styles.label}>How</div>
          {how}
        </div>
        <div className={`${styles.box} ${styles.when}`} data-testid="desc-when">
          <div className={styles.label}>When</div>
          {when}
        </div>
      </div>
    </div>
  )
}
